import React, { useContext, useState } from "react";
import { Button } from "../../../../controls";
import { RestoreRounded } from "@mui/icons-material";
import { Dialog, Snackbar } from "../../../../layout";
import ParkSaleForm from "./ParkSaleForm";
import { CartContext } from "../POS";

const ParkSale = () => {
  const { cartData } = useContext(CartContext);
  const [showForm, setShowForm] = useState(false);

  const [snackbar, setSnackbar] = useState({
    show: false,
    type: "error",
    msg: "",
  });

  const handleParkSale = () => {
    if (
      cartData &&
      cartData.sellItems.length > 0 &&
      cartData.payments.length === 0
    ) {
      setShowForm(!showForm);
    } else if (cartData.payments.length > 0)
      setSnackbar({
        show: true,
        type: "error",
        msg: "You can't park with payments.",
      });
    else
      setSnackbar({
        show: true,
        type: "error",
        msg: "You can't park, your sale list is empty.",
      });
  };

  return (
    <>
      <Button
        onClick={handleParkSale}
        variant="text"
        className="shadow-md border !border-slate-300 !min-w-[120px]"
        startIcon={<RestoreRounded />}
      >
        Park Sale
      </Button>

      {/* Park Sale Form */}
      {showForm && (
        <Dialog show={showForm} onClose={false} maxWidth="xs">
          <ParkSaleForm {...{ setShowForm, setSnackbar }} />
        </Dialog>
      )}

      {snackbar && (
        <Snackbar
          autoHideDuration={2000}
          snackbar={snackbar}
          setSnackbar={setSnackbar}
        />
      )}
    </>
  );
};

export default ParkSale;
